import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'validDomainEmail'
})
export class ValidDomainEmailPipe implements PipeTransform {
  readonly emailRegex = /^[a-zA-Z0-9._!#$%&'*+/=?`{|}~^-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  transform(email: string, allowedDomains: string[]): boolean {
    if (!email) {
      return false;
    }
    const emailLower = email.toLowerCase();
    if (!this.emailRegex.test(emailLower)) {
      return false;
    }
    return allowedDomains
      .map(d => `@${d.toLowerCase()}`)
      .some(domain => emailLower.endsWith(domain));
  }
}
